"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterplanetaryCinematics = void 0;
const Card_1 = require("../../Card");
const Tags_1 = require("../../Tags");
const CardType_1 = require("../../CardType");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Resources_1 = require("../../../Resources");
class InterplanetaryCinematics extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.INTERPLANETARY_CINEMATICS,
            tags: [Tags_1.Tags.BUILDING],
            startingMegaCredits: 30,
            metadata: {
                cardNumber: 'R19',
                description: 'You start with 20 steel and 30 M€.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br.br;
                    b.megacredits(30).nbsp().steel(20).digit;
                    b.corpBox('effect', (ce) => {
                        ce.effect('Each time you play an event, you gain 2 M€.', (eb) => {
                            eb.event().played.startEffect.megacredits(2);
                        });
                    });
                }),
            },
        });
    }
    onCardPlayed(player, card) {
        if (player.isCorporation(this.name) && card.cardType === CardType_1.CardType.EVENT) {
            player.megaCredits += 2;
        }
    }
    play(player) {
        player.addResource(Resources_1.Resources.STEEL, 20);
        return undefined;
    }
}
exports.InterplanetaryCinematics = InterplanetaryCinematics;
//# sourceMappingURL=InterplanetaryCinematics.js.map